<template>
	<div>
		<a-modal title="添加排班" :width="540" :visible="visible" @cancel="handleCancel">
			<template slot="footer">
				<a-button key="back" @click="handleCancel">
					取消
				</a-button>
				<a-button key="submit" type="primary" @click="onSubmit" :loading="confirmLoading">
					确认添加
				</a-button>
			</template>
			<a-spin :spinning="loading">
				<a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
						
					<a-form-model-item :label="'已选'+artificer" >
						<div class=" flex alcenter" style="line-height: 1;">
							<img :src="info.face" class="technician-face"/>
							<div class="ml10">
								<div class="ft14 ftw500 cl-black">{{info.name}}</div>
								<div class="ft12 ftw400 cl-info mt5">{{info.mobile}}</div>
							</div>
						</div>
					</a-form-model-item>
					
					<a-form-model-item label="当前日期" >
						{{day}}
					</a-form-model-item>
					
					
					<a-form-model-item label="工作时间" required>
						<select-time-range v-model="form.scheduling_time"></select-time-range>
					</a-form-model-item>
					<a-form-model-item label="排班步长" required>
						<div class="flex alcenter wrap">
							<template v-for="(item,index) in appointment_intervals">
								<div class="appointment-interval-item active" v-if="item.interval==form.appointment_interval">{{item.info}}</div>
								<div class="appointment-interval-item" v-else @click="chooseAppointmentIntervalsAct(index)">{{item.info}}</div>
							</template>
							
						</div>
					</a-form-model-item>	
					<a-form-model-item label="同时段预约数" required>
						<a-input-number :formatter="value => `${value} 人`" v-model="form.appointment_num" :min="0" :precision="0"
						 placeholder="请输入同时段预约数" style="width: 150px;"  />
					</a-form-model-item>
					
					<a-form-model-item label="复制排班" required help="根据实际情况操作">
						<a-radio-group v-model="form.copy">
						      <a-radio :value="0">
						        不复制
						      </a-radio>
						      <a-radio :value="3">
						        3天
						      </a-radio>
						      <a-radio :value="6">
						        6天
						      </a-radio>
						      <a-radio :value="30">
						        30天
						      </a-radio>
							  <!-- <a-radio :value="60">
							    60天
							  </a-radio> -->
							  <!-- <a-radio :value="365">
							    365天
							  </a-radio> -->
						    </a-radio-group>
					</a-form-model-item>
				</a-form-model>	
				
				
			</a-spin>
		</a-modal>
	</div>
</template>

<script>
	import selectTimeRange from '../../order/modal/addAppointment/selectTimeRange.vue';
	export default {
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			technician_id:{
				type:Number,
				default:0,
			},
			day:{
				type:String,
				default:'',
			}
		},
		components:{
		
			selectTimeRange
		},
		created() {
			this.loaddata();
		},
		data() {
			return {
				appointment_intervals:[
					{interval:20,info:'20分钟'},
					{interval:30,info:'30分钟'},
					{interval:50,info:'50分钟'},
					{interval:60,info:'1小时'},
					{interval:90,info:'90分钟'},
					{interval:120,info:'2小时'}
				],
				loading: false,
				confirmLoading: false,
				chooseProjectVisible:false,
				labelCol: { span: 6 },
				wrapperCol: { span: 18 },
				info:{
					face:'',
					name:'',
					mobile:'',
					scheduling_time:[]
				},
				form: {
					scheduling_time:['09:00', '18:00'],
					copy:0,
					appointment_num:1,
					appointment_interval:60,
				}
			}
		},
		
		created() {
			this.loaddata();
		},
		methods: {
			loaddata(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/showTechnicianFromScheduling',{
					technician_id:this.technician_id,
					day:this.day,
				}).then(res=>{
					this.info=res.info;
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
					this.$emit("cancel");
				})
			},
			
		
			chooseAppointmentIntervalsAct(index){
				this.form.appointment_interval=this.appointment_intervals[index].interval;
			},
			/**
			 * 取消弹窗
			 */
			handleCancel() {
				this.$emit("cancel");
			},

			/**
			 * 提交数据
			 */
			onSubmit() {
			
			
				if(this.confirmLoading==true) return;
				this.confirmLoading=true;
				this.$http.api('admin/saveTechnicianScheduling',{
					technician_id:this.technician_id,
					day:this.day,
					copy:this.form.copy,
					scheduling_time:this.form.scheduling_time,
					appointment_num:this.form.appointment_num,
					appointment_interval:this.form.appointment_interval,
				}).then(res=>{
					this.$message.success('添加成功',1,()=>{
						this.confirmLoading=false;
						this.$emit('ok');
					})
					
				}).catch(res=>{
					console.log(res);
					this.confirmLoading=false;
				})
			},

		}

	}
</script>

<style>
	
	
	.technician-face{
		width: 40px;
		height: 40px;
		border-radius: 2px;
	}
	
	.add-scheduling-time-item{
		border: 1px solid #EBEDF5;
		padding: 0px 10px;
		margin-right: 10px;
		margin-bottom: 10px;
		
	}
	
	.appointment-interval-item{
		padding: 11px 20px;
		border-radius: 4px;
		border: 1px solid #EBEDF5;
		line-height: 1;
		font-size: 14px;
		font-weight: 500;
		color: #232529;
		margin-right: 10px;
		margin-bottom: 10px;
		cursor: pointer;
	}
	
	.appointment-interval-item.active{
		border: 1px solid #4772FF;
		color: #4772FF;
	}
</style>
